import { AxiosError } from "axios";
import axiosInstanceV2 from "../config/axios-v2-config";

const BASE_FREQUENCY_URL = "/v1/prescription-length";
const BASE_FREQUENCY_URL_V2 = "/v2/prescription-length";

export const getLengths = async (includeDeleted: boolean = false) => {
  try {
    // Patient page calls with no arg → soft-deleted rows are excluded by the backend.
    // Admin panel passes true to also load soft-deleted rows so they can be toggled back.
    const response = await axiosInstanceV2.get(BASE_FREQUENCY_URL_V2, {
      params: includeDeleted ? { include_deleted: true } : undefined,
    });
    if (response.status !== 200) {
      throw Error("Unable retrieve prescription length names data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw Error("Unable retrieve prescription length names data");
  }
};

export const setLengthSoftDeleted = async (
  id: string,
  softDeleted: boolean
) => {
  try {
    const response = await axiosInstanceV2.patch(
      `${BASE_FREQUENCY_URL_V2}/${id}`,
      { soft_deleted: softDeleted }
    );
    if (response.status !== 200) {
      throw Error("Unable to update prescription length");
    }
    return response.data;
  } catch (error) {
    console.error(error);
    if (error instanceof AxiosError) {
      const detail = error.response?.data?.detail;
      throw Error(detail || "Unable to update prescription length");
    }
    throw Error("Unable to update prescription length");
  }
};

export const addNewLengths = async ({
  lengthName,
  flengthDescription,
}: {
  lengthName: string;
  flengthDescription: string;
}) => {
  try {
    const response = await axiosInstanceV2.post(BASE_FREQUENCY_URL_V2, {
      name: lengthName,
      description: flengthDescription,
    });
    if (response.status !== 201) {
      throw Error("Unable save prescription length data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable save prescription length data");
  }
};

export const updateLength = async (
  id: string,
  {
    lengthName,
    flengthDescription,
  }: {
    lengthName: string;
    flengthDescription: string;
  }
) => {
  try {
    const response = await axiosInstanceV2.patch(
      `${BASE_FREQUENCY_URL_V2}/${id}`,
      {
        name: lengthName,
        description: flengthDescription,
      }
    );
    if (response.status !== 200) {
      throw Error("Unable to update prescription length");
    }
    return response.data;
  } catch (error) {
    console.error(error);
    // Surface the backend's error detail (e.g. 409 duplicate name) so the caller can toast it.
    if (error instanceof AxiosError) {
      const detail = error.response?.data?.detail;
      throw Error(detail || "Unable to update prescription length");
    }
    throw Error("Unable to update prescription length");
  }
};

export const deleteLength = async (id: string) => {
  try {
    const response = await axiosInstanceV2.delete(
      `${BASE_FREQUENCY_URL_V2}/${id}`
    );
    if (response.status !== 200 && response.status !== 204) {
      throw Error("Unable to delete prescription length");
    } else {
      return response.data;
    }
  } catch (error) {
    console.error(error);
    throw Error("Unable to delete prescription length");
  }
};
